import React, {Component} from 'react';
import {Form} from "react-bootstrap";

class MultipleChoice extends Component {
    constructor(props) {
        super(props);
        this.state= {
            selected:  this.props.elementProps?.defaultValue || []
        }
    }



    setAnswer = (e) => {
        //console.log(e.target.dataset.value)
        if (e.target.checked){
            this.setState(prevState=> {
                return {
                    ...prevState,
                    selected: [...new Set([...prevState.selected, e.target.dataset.value])]
                }
            },()=>{
                this.props.setAnswer(this.state.selected)
                //console.log(this.state.selected)
            })
        }
        else{
            this.setState(prevState=>{
                return {
                    ...prevState,
                    selected: prevState.selected.filter(i=>i !== e.target.dataset.value)
                }
            },()=>{
               this.props.setAnswer(this.state.selected)
               // console.log(this.state.selected)
            })
        }

    }

    render() {
        //console.log(this.props.elementProps.defaultValue)
        return (
            <div className="row g-2">
                {
                    this.props.choices.map((choice,i)=>{
                        const Label = <div className={`d-flex flex-column align-items-center ${choice?.icon ? 'py-2':'py-3'} px-3`}>{choice.icon} <span
                            className="text-nowrap">{choice.text} </span></div>
                        const id = this.props.elementProps.id+choice.value

                        return (
                            <div key={id} className={`col-6 transitionable delay-${2+i}`}>
                                <Form.Check
                                    onClick={this.setAnswer}
                                    type="checkbox"
                                    id={id}
                                    name={this.props.elementProps.id}
                                    label={choice.text}
                                    data-value={choice.value}
                                    defaultChecked={this.props.elementProps.defaultValue && this.props.elementProps.defaultValue.includes(choice.value)}/>
                            </div>

                        )
                    })
                }
            </div>
        );
    }
}

export default MultipleChoice;